import { render } from "./BusinessClassificationList.vue?vue&type=template&id=ffc819b6&scoped=true"
import script from "./BusinessClassificationList.vue?vue&type=script&lang=js"
export * from "./BusinessClassificationList.vue?vue&type=script&lang=js"

import "./BusinessClassificationList.vue?vue&type=style&index=0&id=ffc819b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc819b6"]])

export default __exports__